import React from 'react';
import PropTypes from 'prop-types';

import { photosShow } from '../../helpers/photosShow';
import { locationuploadDir } from '../../config';

// Assets
import mediumNoImage from './medium_no_image.png';
import largeNoImage from './large_no_image.jpeg';

function ListPopularLocationPhoto({ listPhotos, className, bgImage = false, children }) {
  const imagePath = photosShow(locationuploadDir);
  const isImageAvailable = !!listPhotos;
  const source = isImageAvailable ? listPhotos : (bgImage ? mediumNoImage : largeNoImage);
  const path = isImageAvailable ? `${imagePath}medium_` : '';

  if (bgImage) {
    return (
      <div className={className} style={{ backgroundImage: `url(${path}${source})` }}>
        {children}
      </div>
    );
  }

  return (
    <img src={path + source} className={className} alt="Popular location" />
  );
}

ListPopularLocationPhoto.propTypes = {
  listPhotos: PropTypes.string,
  className: PropTypes.string,
  bgImage: PropTypes.bool,
  children: PropTypes.node
};

ListPopularLocationPhoto.defaultProps = {
  bgImage: false
};

export default React.memo(ListPopularLocationPhoto);
